import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  onDark = true
}: {
  onDark?: boolean;
}) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'HOURS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="w-full" data-id="element-1" data-mp="374mas3fanb4y">
      <p className={`text-center font-display text-[11px] font-bold uppercase tracking-[0.22em] ${onDark ? 'text-gold-500' : 'text-brand-600'}`} data-id="element-2" data-mp="10btlzpmvx2s3">
        This offer expires in
      </p>
      <div className="mt-3 grid grid-cols-3 gap-2 sm:gap-3" data-id="element-3" data-mp="xzvipeo9v61p">
        {units.map(unit => <div key={unit.label} className={`rounded-xl px-2 py-3 text-center ${onDark ? 'bg-white/10 ring-1 ring-white/15' : 'bg-navy-900 ring-1 ring-navy-800'}`} data-id="element-4" data-mp="t125zogt7j2l">
            <span className="block font-display text-3xl font-black tabular-nums text-white sm:text-4xl" aria-hidden="true" data-id="element-5" data-mp="12sokpuscw0a3">
              {unit.value}
            </span>
            <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.18em] text-brand-100/70" data-id="element-6" data-mp="a5bwzhaglmf7">
              {unit.label}
            </span>
          </div>)}
      </div>
      <p className="sr-only" aria-live="off" data-id="element-7" data-mp="k3hzo143awl4">
        {`Time left: ${pad(hours)} hours, ${pad(minutes)} minutes, ${pad(seconds)} seconds`}
      </p>
    </div>;
}